<template>
  <q-card
    class="my-card"
    flat
    bordered
    :style="`border-color: ${props.borderColor}`"
  >
    <q-card-section :class="[$props.color, $props.textColor]">
      <div class="row" @click="expanded = !expanded" style="cursor: pointer">
        <div class="col">
          <slot>
            <div class="text-overline text-orange-9">Overline</div>
            <div class="text-h5 q-mt-sm q-mb-xs">Title</div>
            <div class="text-caption text-grey">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>
          </slot>
        </div>
        <q-btn
          round
          style="height: fit-content"
          flat
          dense
          :icon="expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
        />
      </div>
    </q-card-section>

    <!-- <q-card-actions class="bg-exphdr-normalclr text-white"> </q-card-actions> -->

    <q-slide-transition>
      <div v-show="expanded">
        <q-separator />
        <q-card-section class="text-subitle2">
          <slot name="dropdown"> </slot>
        </q-card-section>
      </div>
    </q-slide-transition>
  </q-card>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  color: { type: String, default: "bg-exphdr-normalclr" },
  textColor: { type: String, default: "text-white" },
  borderColor: { type: String },
});

const expanded = ref(false);
</script>

<style lang="sass" scoped>
.my-card
  width: 100%
</style>
